import React from 'react'
import { reduxForm } from 'redux-form'
import { FORM_CEREALES } from '../../../../config/forms'
import CamposCereal from './CamposCereal'

function EdicionCereal () {
  return (
    <div style={{ padding: '2%' }}>
      <CamposCereal />
    </div>
  )
}

const withReduxForm = reduxForm({
  form: FORM_CEREALES,
  enableReinitialize: true
})

export default withReduxForm(EdicionCereal)
